import clsx from "clsx"
import { useEffect, useState } from "react"
import { Icon } from "@/components/icons/Icon"
import { Spinner } from "@/components/ui/Spinner"

export const PeopleDetectionLoadingPanel = (props: { className?: string }) => {
	const messages = ["initializing...", "detecting people...", "analyzing masks..."]
	const [messageIndex, setMessageIndex] = useState(0)

	useEffect(() => {
		const timers = [
			setTimeout(() => setMessageIndex(1), 600),
			setTimeout(() => setMessageIndex(2), 1800),
		]

		return () => {
			timers.forEach(clearTimeout)
		}
	}, [])

	return (
		<div
			className={clsx(
				"flex flex-col items-center justify-center gap-3 py-3 text-center",
				props.className ?? "min-h-28",
			)}
		>
			<div className="relative flex size-10 items-center justify-center text-base-300">
				<Icon name="people_mask" size={24} />
				<Spinner className="absolute text-accent-500" size={40} />
			</div>
			<div className="text-sm text-base-200">{messages[messageIndex]}</div>
		</div>
	)
}
